import Validation from "./lib/validationAllFields";
import { format } from "./intl/format";

export default function validate(state) {
  // TODO: Refactor. Use simple selector from intl, for mapStateToProps as well.
  const intl = state.intl;
  const msg = intl.messages[intl.selectedLanguage];

  class LocalizedValidation extends Validation {
    getRequiredMessage(prop) {
      return format(msg.app.validation.required, {
        prop
      });
    }

    getEmailMessage(prop) {
      return format(msg.app.validation.email, {
        prop
      });
    }

    getRangeMessage(prop, value, field, from, to) {
      if (from == null) {
        return format(msg.app.validation.rangeTo, {
          prop,
          value,
          field,
          to
        });
      }
      if (to == null) {
        return format(msg.app.validation.rangeFrom, {
          prop,
          value,
          field,
          from
        });
      }
      return format(msg.app.validation.range, {
        prop,
        value,
        field,
        from,
        to
      });
    }

    getSimplePasswordMessage(minLength) {
      return format(msg.app.validation.password, {
        minLength
      });
    }
  }

  const validate = (object, oneField) =>
    new LocalizedValidation(object, oneField);

  validate.wrongPassword = prop =>
    new Validation.ValidationError(msg.auth.form.wrongPassword, prop);

  return validate;
}



// WEBPACK FOOTER //
// ./src/common/validate.js